import * as React from "react";
import { useLink } from "@grandvisionhq/frk-routing";
import { sanitizeStringForUrl, getProductKeyFromCTType } from "@grandvisionhq/utils";
import { isContactLensVariant } from "../../../../../../../../types/types/typeguards.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
const useBrandLink = () => {
  const {
    activeVariant,
    product: { brandName, productType }
  } = useProductData();
  const link = useLink({
    route: "products.list",
    params: {
      type: getProductKeyFromCTType(productType),
      subCategory: sanitizeStringForUrl(brandName)
    }
  });
  const brandLink = React.useMemo(() => {
    if (isContactLensVariant(activeVariant)) return void 0;
    if (!link?.href) return void 0;
    return link.href;
  }, [activeVariant, link]);
  return brandLink;
};
export {
  useBrandLink
};
//# sourceMappingURL=use-brand-link.js.map
